import { useSelector } from 'react-redux'
import { selectRobot } from 'store/selectors/robot'
import { VENDOR } from 'utils/vendorDisplayName'

import RobotAdditionalInfo from './RobotAdditionalInfo/RobotAdditionalInfo'
import RobotInfo from './RobotInfo/RobotInfo'
import RobotMissionMainStatus from './RobotMissionMainStatus/RobotMissionMainStatus'

import style from './RobotDetails.module.css'

const RobotDetails = () => {
  const robot = useSelector(selectRobot)
  const isAsbis = robot.robotInfo?.vendor === VENDOR.ASBIS

  return (
    <div className={style.root}>
      <div className={style.tableWrapper}>
        <RobotMissionMainStatus />
        <RobotInfo />
      </div>
      {!isAsbis && <RobotAdditionalInfo />}
    </div>
  )
}

export default RobotDetails
